<template>
  <div class="sensor-state-wrap">
    <span class="iconfont" :class="option.ico" :style="{ color: option.color }"></span>
    <span>{{ option.text }}</span>
  </div>
</template>

<script>
import { getStateOption } from '@/utils/deviceUtils/state';

export default {
  props: {
    runstate: [Number, String],
    state: [Number, String],
    normalColor: String
  },
  computed: {
    option() {
      let {
        c: color,
        t: text,
        ico
      } = getStateOption({
        runstate: this.runstate,
        state2: this.state
      });
      if (color === 'unset') color = this.normalColor || color;
      return { color, text, ico };
    }
  }
};
</script>

<style lang="scss">
.sensor-state-wrap {
  display: inline-block;
}
</style>
